export const testCSPImplementation = () => {
  const tests = {
    resources: {
      scripts: false,
      styles: false,
      images: false,
      fonts: false,
      firebase: false
    },
    errors: []
  };

  // Test script loading
  try {
    const testScript = document.createElement('script');
    testScript.src = '/test.js';
    document.head.appendChild(testScript);
    tests.resources.scripts = true;
  } catch (error) {
    tests.errors.push('Script loading failed: ' + error.message);
  }

  // Test style loading
  try {
    const testStyle = document.createElement('link');
    testStyle.rel = 'stylesheet';
    testStyle.href = '/test.css';
    document.head.appendChild(testStyle);
    tests.resources.styles = true;
  } catch (error) {
    tests.errors.push('Style loading failed: ' + error.message);
  }

  // Test image loading
  try {
    const testImage = new Image();
    testImage.src = '/test.jpg';
    tests.resources.images = true;
  } catch (error) {
    tests.errors.push('Image loading failed: ' + error.message);
  }

  // Test font loading
  try {
    const testFont = document.createElement('link');
    testFont.rel = 'stylesheet';
    testFont.href = 'https://fonts.googleapis.com/css2?family=Test&display=swap';
    document.head.appendChild(testFont);
    tests.resources.fonts = true;
  } catch (error) {
    tests.errors.push('Font loading failed: ' + error.message);
  }

  // Test Firebase connection
  try {
    const firebaseTest = document.createElement('script');
    firebaseTest.src = 'https://www.gstatic.com/firebasejs/10.7.2/firebase-app.js';
    document.head.appendChild(firebaseTest);
    tests.resources.firebase = true;
  } catch (error) {
    tests.errors.push('Firebase connection failed: ' + error.message);
  }

  return tests;
}; 